export interface QuantizedPoint {
  x: number;
  y: number;
}

export function QuantizedSine(bits: number, normfreq: number, cycles = 1.5): QuantizedPoint[] {
  const halfSteps = (Math.pow(2, Math.round(bits)) - 1) / 2;
  const count = Math.max(4, Math.round(normfreq * 48) + 4);
  return Array.from({ length: count + 1 }, (_, x) => {
    const raw = Math.sin((x / count) * Math.PI * 2 * cycles);
    return { x, y: halfSteps > 0 ? Math.round(raw * halfSteps) / halfSteps : 0 };
  });
}
